<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <settingsMenu></settingsMenu>
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Artykuły</h4>
              <button v-if="hasPermission('canEditUbrania')" @click="addArtykul" class="btn btn-primary btn-sm">
                <i class="bi bi-plus-circle me-2"></i>Dodaj nowy artykul
              </button>
              <button v-if="hasPermission('canEditUbrania')" @click="openRozmiarModal"
                      class="btn btn-outline-primary btn-sm ms-2">
                <i class="bi bi-plus-circle me-2"></i>Dostępne rozmiary
              </button>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="custom-table">
            <div class="table-responsive">
              <table class="table table-bordered table-hover">
                <thead>
                <tr>
                  <th>#</th>
                  <th>Nazwa</th>
                  <th>Opis</th>
                  <th>Wymiana</th>
                  <th>Grupa</th>
                  <th v-if="hasPermission('canEditUbrania')">Akcje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-if="addingNew">
                  <td>Nowy</td>
                  <td><input v-model="newArtykul.nazwa" class="form-control" style="min-width:200px;"/></td>
                  <td><input v-model="newArtykul.opis" class="form-control" style="min-width:200px;"/></td>
                  <td>
                    <select id="waznosc" v-model="newArtykul.wymiana" class="form-control" style="min-width:200px;">
                      <option value="">-- wybierz --</option>
                      <option v-for="year in 5" :key="year" :value="year">
                        {{ year }} {{ year === 1 ? 'rok' : (year >= 2 && year <= 4 ? 'lata' : 'lat') }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <select v-model="newArtykul.grupa_id" class="form-select" style="min-width:200px;">
                      <option disabled value="">-- Wybierz grupę --</option>
                      <option v-for="t in grupy" :key="t.id" :value="t.id">{{ t.nazwa }}</option>
                    </select>
                  </td>
                  <td>
                    <button @click="saveNewArtykul" class="btn btn-sm btn-success me-1 mb-2"><i
                        class="bi bi-save me-2"></i>Zapisz
                    </button>
                    <button @click="cancelNewArtykul" class="btn btn-sm btn-danger"><i class="bi bi-x-circle me-2"></i>Anuluj
                    </button>
                  </td>
                </tr>
                <tr v-for="(artykul, index) in artykuly" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <input v-if="editingId === artykul.id" v-model="artykul.nazwa" class="form-control"/>
                    <span v-else>{{ artykul.nazwa }}</span>
                  </td>
                  <td>
                    <input v-if="editingId === artykul.id" v-model="artykul.opis" class="form-control"/>
                    <span v-else>{{ artykul.opis }}</span>
                  </td>
                  <td>
                    <select v-if="editingId === artykul.id" v-model="artykul.wymiana" class="form-select">
                      <option value="">-- wybierz --</option>
                      <option v-for="year in 5" :key="year" :value="year">
                        {{ year }} {{ year === 1 ? 'rok' : (year >= 2 && year <= 4 ? 'lata' : 'lat') }}
                      </option>
                    </select>
                    <span v-else> <span v-if="artykul.wymiana">{{ artykul.wymiana * 365 }} dni</span></span>
                  </td>
                  <td>
                    <select v-if="editingId === artykul.id" v-model="artykul.grupa_id" class="form-select">
                      <option disabled value="">-- Wybierz grupę --</option>
                      <option v-for="t in grupy" :key="t.id" :value="t.id">{{ t.nazwa }}</option>
                    </select>
                    <span v-else>{{ getGrupaName(artykul.grupa_id) }}</span>
                  </td>
                  <td v-if="hasPermission('canEditUbrania')">
                    <button v-if="editingId === artykul.id" @click="updateArtykul(artykul)"
                            class="btn btn-sm btn-success me-2 mb-1 mt-1">Zapisz
                    </button>
                    <button v-else @click="editArtykul(artykul.id)" class="btn btn-sm btn-outline-info me-2 mb-1 mt-1">
                      <i class="bi bi-pencil me-2"></i>Edytuj
                    </button>
                    <button @click="deleteArtykul(artykul.id)" class="btn btn-sm btn-danger me-2  mb-1 mt-1"><i
                        class="bi bi-trash me-2"></i>Usuń
                    </button>
                    <button class="btn btn-sm btn-outline-primary mb-1 mt-1" @click="openRozmiaryModal(artykul)">
                      Rozmiary
                    </button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-if="isModalOpenAddArt" class="modal fade show" tabindex="-1" style="display: block;">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Dostępne rozmiary</h5>
                <button type="button" class="btn-close" @click="closeRozmiaryModal"></button>
              </div>
              <div class="modal-body">
                <div class="d-grid rozmiary-grid">
                  <div v-for="rozmiar in sortedRozmiary" :key="rozmiar.id" class="form-check">
                    <input class="form-check-input" type="checkbox" :id="'check-' + rozmiar.id"
                           v-model="selectedRozmiary" :value="rozmiar.id">
                    <label class="form-check-label" :for="'check-' + rozmiar.id">{{ rozmiar.nazwa }}</label>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" @click="closeRozmiaryModal">Zamknij</button>
                <button class="btn btn-success" @click="saveRozmiary">Zapisz</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="isModalOpenAddRozmiar" class="modal fade show" tabindex="-1" style="display: block;">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Lista rozmiarów</h5>
                <button type="button" class="btn-close" @click="closeRozmiarModal"></button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <button @click="addNewRozmiar" class="btn btn-success btn-sm mb-2"><i
                        class="bi bi-plus-circle me-2"></i>Dodaj nowy rozmiar
                    </button>
                    <div class="custom-table ">
                      <div class="table-responsive">
                        <table class="table table-bordered table-hover">
                          <thead>
                          <tr>
                            <th>Nazwa</th>
                            <th>Opis</th>
                            <th>Pozycja</th>
                            <th v-if="hasPermission('canEditUbrania')">Akcje</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-if="addingNewRozmiar">
                            <td style="width:25%"><input v-model="newRozmiar.nazwa" class="form-control"/></td>
                            <td style="width:30%"><input v-model="newRozmiar.opis" class="form-control"/></td>
                            <td style="width:10%"></td>
                            <td>
                              <button @click="saveRozmiar" class="btn btn-sm btn-success me-1 mb-1 mt-1"><i
                                  class="bi bi-save me-2"></i>Zapisz
                              </button>
                              <button @click="cancelNewRozmiar" class="btn btn-sm btn-secondary mb-1 mt-1"><i
                                  class="bi bi-x-circle me-2"></i>Anuluj
                              </button>
                            </td>
                          </tr>
                          <tr v-for="(rozmiar, index) in sortedRozmiary" :key="rozmiar.id">
                            <td style="width:25%">
                              <input v-if="editingRozmiarId === rozmiar.id" v-model="rozmiar.nazwa"
                                     class="form-control"/>
                              <span v-else>{{ rozmiar.nazwa }}</span>
                            </td>
                            <td style="width:30%">
                              <input v-if="editingRozmiarId === rozmiar.id" v-model="rozmiar.opis"
                                     class="form-control"/>
                              <span v-else>{{ rozmiar.opis }}</span>
                            </td>
                            <td class="text-center" style="width:10%" v-if="hasPermission('canEditUbrania')">
                              <button class="mb-1 mt-1 me-2" @click="moveUp(index)" :disabled="index === 0">↑</button>
                              <button class="mb-1 mt-1 me-2" @click="moveDown(index)"
                                      :disabled="index === rozmiary.length - 1">↓
                              </button>
                            </td>
                            <td v-if="hasPermission('canEditUbrania')">
                              <button v-if="editingRozmiarId === rozmiar.id" @click="updateRozmiar(rozmiar)"
                                      class="btn btn-sm btn-success me-2 mb-1 mt-1">Zapisz
                              </button>
                              <button v-else @click="editRozmiar(rozmiar)"
                                      class="btn btn-sm btn-outline-info me-2 mb-1 mt-1"><i
                                  class="bi bi-pencil me-2"></i>Edytuj
                              </button>
                              <button @click="deleteRozmiar(rozmiar.id)" class="btn btn-sm btn-danger me-2 mb-1 mt-1">
                                Usuń
                              </button>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import settingsMenu from "@/Pages/BHP/parts/settingsMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, settingsMenu},
  props: {
    grupy: Array,
    artykuly: Array,
    rozmiary: Array,
	
  },
  data() {
    return {
      hasPermission,
      editingId: null,
      addingNew: false,
      addingNewRozmiar: false,
      newArtykul: this.getEmptyForm(),
      selectedRozmiary: [], // zaznaczone checkboxy
      isModalOpenAddArt: false,
      activeArtykul: null,
      editingRozmiarId: null,
      editedRozmiar: {},
      newRozmiar: this.getEmptyFormRozmiar(),
      localRozmiary: [...this.rozmiary],
      isModalOpenAddRozmiar: false
    };
  },
  computed: {
    sortedRozmiary() {
      return [...this.localRozmiary].sort((a, b) => a.position - b.position);
    }
  },
  methods: {
    cancelEditRozmiar() {
      this.editingRozmiarId = null;
    },

    editRozmiar(rozmiar) {
      this.editingRozmiarId = rozmiar.id;
      this.editedRozmiar = {...rozmiar};
    },

    updateRozmiar(rozmiar) {
      this.editedRozmiar = {...rozmiar};
      this.$inertia.put(route('bhp.grupy.artykuly.rozmiar.update', rozmiar.id), rozmiar, {
        onSuccess: () => {
          this.editingRozmiarId = null;
        }
      });
    },

    addNewRozmiar() {
      this.addingNewRozmiar = true;
      this.newRozmiar = this.getEmptyFormRozmiar();
    },

    cancelNewRozmiar() {
      this.addingNewRozmiar = false;
      this.newRozmiar = this.getEmptyFormRozmiar();
    },

    saveRozmiar() {
      this.$inertia.post(route('bhp.grupy.artykuly.rozmiar.dodaj'), this.newRozmiar, {
        onSuccess: () => {
          this.newRozmiar = this.getEmptyFormRozmiar();
        }
      });
    },

    moveUp(index) {
      if (index === 0) return;
      const temp = this.localRozmiary[index - 1];
      this.$set(this.localRozmiary, index - 1, this.localRozmiary[index]);
      this.$set(this.localRozmiary, index, temp);
      this.updatePositions();
      this.savePositions();
    },

    moveDown(index) {
      if (index === this.localRozmiary.length - 1) return;
      const temp = this.localRozmiary[index + 1];
      this.$set(this.localRozmiary, index + 1, this.localRozmiary[index]);
      this.$set(this.localRozmiary, index, temp);
      this.updatePositions();
      this.savePositions();
    },

    updatePositions() {
      this.localRozmiary.forEach((r, idx) => r.position = idx + 1);
    },

    savePositions() {
      const payload = this.localRozmiary.map(r => ({id: r.id, position: r.position}));
      this.$inertia.post(route('bhp.rozmiary.position'), {position: payload});
    },

    deleteRozmiar(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie rozmiaru',
        html: 'Czy na pewno chcesz usunąć wybrany rozmiar?',
        showDenyButton: true,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('bhp.grupy.artykuly.rozmiar.usun', id));
        }
      })
    },

    closeRozmiarModal() {
      this.isModalOpenAddRozmiar = false;
      this.newRozmiar = this.getEmptyFormRozmiar();
    },

    openRozmiarModal() {
      this.isModalOpenAddRozmiar = true;
    },

    saveRozmiary() {
      this.$inertia.post(
          route('bhp.grupy.artykuly.updateRozmiary', this.activeArtykul.id),
          {rozmiary: this.selectedRozmiary},
          {
            onSuccess: () => {
              this.isModalOpenAddArt = false;
            }
          }
      );
    },

    closeRozmiaryModal() {
      this.isModalOpenAddArt = false;
      this.activeArtykul = null;
      this.selectedRozmiary = [];
    },

    openRozmiaryModal(artykul) {
      this.activeArtykul = artykul;
      this.selectedRozmiary = artykul.rozmiary.map(r => r.id);
      this.isModalOpenAddArt = true;
    },

    getEmptyFormRozmiar() {
      return {
        id: null,
        nazwa: '',
        opis: '',
      };
    },

    getGrupaName(id) {
      const grupa = this.grupy.find(g => g.id === id);
      return grupa ? grupa.nazwa : '';
    },
	
    getEmptyForm() {
      return {
        id: null,
        name: '',
        opis: '',
        grupa_id: 1,
        wymiana: '',
      };
    },

    addArtykul() {
      this.addingNew = true;
      this.newArtykul = this.getEmptyForm();
    },

    cancelNewArtykul() {
      this.addingNew = false;
      this.newArtykul = this.getEmptyForm();
    },

    editArtykul(id) {
      this.editingId = id;
    },

    updateArtykul(artykul) {
      this.$inertia.put(route('bhp.grupy.artykuly.update', artykul.id), artykul, {
        onSuccess: () => {
          this.editingId = null;
        }
      });
    },

    saveNewArtykul() {
      this.$inertia.post(route('bhp.grupy.artykuly.dodaj'), this.newArtykul, {
        onSuccess: () => {
          this.addingNew = false;
          this.newArtykul = this.getEmptyForm();
        }
      });
    },

    deleteArtykul(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie artykułu z grupy produktów',
        html: 'Czy na pewno chcesz usunąć wybrany artykuł z grupy produktów?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$inertia.delete(route('bhp.grupy.artykuly.usun', id));
        }
      });
    }
  }
};
</script>
<style scoped>
.rozmiary-grid {
  display: grid;
  grid-template-rows: repeat(7, auto);
  grid-auto-flow: column;
  gap: 10px 20px;
}

</style>